import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";
import ValuesOne from "../components/values/ValuesOne";
import BlockPrincipal from "../components/block/Block_3";
import BlockSecondary from "../components/block/Block_1";


function About() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="About">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="About"
          Subheader="About"
        />
        <BlockPrincipal
            title={'a little about us'}
            text={rpdata?.dbAbout?.[1]?.text}
            image={rpdata?.stock?.[0]}
            image2={rpdata?.stock?.[11]}
            image3={rpdata?.stock?.[5]}
            image4={rpdata?.stock?.[22]}
            listsAbout={true}
          />
        <ValuesOne image={rpdata?.stock?.[5]} />

        <BlockSecondary
          title={rpdata?.dbSlogan?.[0]?.slogan}
          text={rpdata?.dbAbout?.[2]?.text}
          image={rpdata?.stock?.[1]}
        />
      </div>
    </BaseLayout>
  );
}

export default About;
